import React, { useEffect, useState } from "react";
import { Typography } from "antd";
import "./index.scss";

interface LoaderProps {
  isLoading: boolean;
  loadingMessage: string | null;
}

const Loader: React.FC<LoaderProps> = ({ isLoading, loadingMessage }) => {
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (!isLoading) return;

    const handleMouseMove = (e: MouseEvent) => {
      setCursorPosition({ x: e.clientX, y: e.clientY });
    };

    document.addEventListener("mousemove", handleMouseMove);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, [isLoading]);

  if (!isLoading) return null;

  const message = loadingMessage ? loadingMessage : "Loading please wait...";

  return (
    <div className="loader_container">
      <div
        className="cursor-shine"
        style={{
          left: cursorPosition.x - 75,
          top: cursorPosition.y - 75,
        }}
      />
      <div className="loader_content">
        <div className="loader-image-wrapper">
          <img
            src="/icons/ai-stars.svg"
            alt="loading"
            className="loader-icon"
          />
        </div>
        <Typography.Text className="loader_message">{message}</Typography.Text>
      </div>
    </div>
  );
};

export default Loader;
